import React from 'react';

export const DefaultUser = () => {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.9746 18.91C18.9746 25.2025 24.0971 30.32 30.3995 30.32C36.687 30.32 41.802 25.2025 41.802 18.91C41.802 12.62 36.687 7.5 30.3995 7.5C24.0971 7.5 18.9746 12.62 18.9746 18.91Z"
        fill="#64748B"
      />
      <path
        d="M17.6758 52.4987H43.0758C47.3433 52.4987 50.3558 49.6537 50.5758 45.3612C50.6033 40.8812 47.8433 37.1087 43.3683 35.5137C41.2433 34.7687 38.8958 35.3487 36.4158 35.9687C34.4933 36.4487 32.5208 36.9112 30.3658 36.9237C28.1958 36.9187 26.2708 36.4437 24.3508 35.9612C21.8633 35.3337 19.5108 34.7437 17.3783 35.5087C12.9358 37.0887 10.1758 40.8637 10.1758 45.4087C10.3633 49.6512 13.3758 52.4987 17.6758 52.4987Z"
        fill="#64748B"
      />
    </svg>
  );
};
